import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { Room } from "../models/Models";
import { InputText } from "primereact/inputtext";
import { OverlayPanel } from "primereact/overlaypanel";
import { Button } from "primereact/button";
import { InputNumber, InputNumberValueChangeEvent } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";

interface RoomPaxInputs {
    rooms: Room[];
    setRooms: Dispatch<SetStateAction<Room[]>>;
}

interface DropdownOptions{
    name: string,
    value: number
}

function RoomPax({ rooms, setRooms }: RoomPaxInputs) {
    var allowedChildAges: DropdownOptions[] = [
        {name:"Under 1",value: 0},
        {name:"1",value: 1},
        {name:"2",value: 2},
        {name:"3",value: 3},
        {name:"4",value: 4},
        {name:"5",value: 5},
        {name:"6",value: 6},
        {name:"7",value: 7},
        {name:"8",value: 8},
        {name:"9",value: 9},
        {name:"10",value: 10},
        {name:"11",value: 11},
        {name:"12",value: 12},
        {name:"13",value: 13},
        {name:"14",value: 14},
        {name:"15",value: 15},
        {name:"16",value: 16},
        {name:"17",value: 17}
    ];

    const emptyRoom: Room = { numOfAdults: 2, numOfChildren: 0, childAges: [] };

    // const [rooms, setRooms] = useState<Room[]>([emptyRoom]);

    const overlay = useRef(null);

    const getTotalAdults = (): number => {
        let total = 0;
        rooms.forEach((room) => {
            total += room.numOfAdults;
        });
        return total;
    };

    const getTotalChildren = (): number => {
        let total = 0;
        rooms.forEach((room) => {
            total += room.numOfChildren;
        });
        return total;
    };

    const toggleOverlay = (e: any) => {

        if (overlay !== null) {
            //@ts-ignore
            overlay.current.toggle(e);
        } else {
            console.warn("overlay null");
        }
    };

    const removeRoom = (index: number) => {
        rooms.splice(index, 1);
        setRoomSummary(`Rooms: ${rooms.length} \u00B7 Adults: ${getTotalAdults()} \u00B7 Children: ${getTotalChildren()}`);
    };

    const addRoom = () => {
        rooms.push(emptyRoom);
        setRoomSummary(`Rooms: ${rooms.length} \u00B7 Adults: ${getTotalAdults()} \u00B7 Children: ${getTotalChildren()}`);
    };

    const handleAdultsChange = (e: InputNumberValueChangeEvent, index: number) => {
        const newRooms = [...rooms];
        newRooms[index].numOfAdults = e.value || 1;
        setRooms(newRooms);
        setRoomSummary(`Rooms: ${rooms.length} \u00B7 Adults: ${getTotalAdults()} \u00B7 Children: ${getTotalChildren()}`);
    };

    const handleChildrenChange = (e: InputNumberValueChangeEvent, index: number, childIndex: number) => {
        const newRooms = [...rooms];
        //@ts-ignore
        if(e.value > rooms[index].numOfChildren){
            newRooms[index].childAges.push(0);
        }
        else{
            newRooms[index].childAges.pop();
        }
        
        newRooms[index].numOfChildren = e.value || 0;
        setRooms(newRooms);
        setRoomSummary(`Rooms: ${rooms.length} \u00B7 Adults: ${getTotalAdults()} \u00B7 Children: ${getTotalChildren()}`);
    };

    const handleChildAgeChange = (age: string, index: number, childIndex: number)=>{
        const newRooms = [...rooms];
        if(age === "Under 1")
            newRooms[index].childAges[childIndex] = 0;
        else
            newRooms[index].childAges[childIndex] = parseInt(age);
        setRooms(newRooms);
    }

    const stopPropagation = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
    };

    const [roomSummary, setRoomSummary] = useState<string>(`Rooms: ${rooms.length} \u00B7 Adults: ${getTotalAdults()} \u00B7 Children: ${getTotalChildren()}`);

    useEffect(() => {
        setRoomSummary(`Rooms: ${rooms.length} \u00B7 Adults: ${getTotalAdults()} \u00B7 Children: ${getTotalChildren()}`);
    }, [rooms]);

    return (
        <>
            <div
                onClick={(e) => {
                    toggleOverlay(e);
                }}
            >
                <div className="p-inputgroup flex-1 m-1">
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-user"></i>
                    </span>
                    <InputText disabled style={{ outline: "none" }} value={roomSummary} placeholder="Room" />
                    <OverlayPanel showCloseIcon ref={overlay}>
                        <div onClick={stopPropagation} style={{ width: "250px" }}>
                            {rooms.map((room, index) => {
                                return (
                                    <div key={"room " + index}>
                                        {
                                            (rooms.length !== 1 && index !== 0) &&
                                            <div className="m-1 mb-3">
                                                <div className="border-bottom-1" style={{borderColor: "rgb(206, 212, 218)"}}></div>
                                            </div>
                                        }
                                        <div className="m-1 p-1" >
                                            <div className="grid p-1">
                                                <div className="col-6">
                                                    <h4 className="m-1">Room {index + 1}</h4>
                                                </div>
                                                {
                                                    index !== 0 &&
                                                    <div className="col-6 text-right p-1">
                                                        {/* <Button icon="pi pi-trash" onClick={()=>{removeRoom(index)}} rounded outlined /> */}
                                                        <i className="pi pi-trash" onClick={()=>{removeRoom(index)}}></i>
                                                    </div>
                                                }
                                            </div>
                                            <div className="grid p-1">
                                                <div className="col-6">
                                                    <p>Adults</p>
                                                </div>
                                                <div className="col-6 text-right my-auto">
                                                    <div className="card flex flex-wrap gap-3 p-fluid">
                                                        <div className="flex-auto">
                                                            <InputNumber
                                                                min={1}
                                                                style={{ width: "120px" }}
                                                                inputId="horizontal-buttons"
                                                                value={room.numOfAdults}
                                                                onValueChange={(e) => {
                                                                    handleAdultsChange(e, index);
                                                                }}
                                                                showButtons
                                                                buttonLayout="horizontal"
                                                                decrementButtonClassName="p-button-secondary"
                                                                incrementButtonClassName="p-button-secondary"
                                                                incrementButtonIcon="pi pi-plus"
                                                                decrementButtonIcon="pi pi-minus"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="grid p-1">
                                                <div className="col-6 ">
                                                    <p>Children</p>
                                                </div>
                                                <div className="col-6 text-right my-auto">
                                                    <div className="card flex flex-wrap gap-3 p-fluid">
                                                        <div className="flex-auto">
                                                            <InputNumber
                                                                min={0}
                                                                style={{ width: "120px" }}
                                                                inputId="horizontal-buttons"
                                                                value={room.numOfChildren}
                                                                onValueChange={(e) => {
                                                                    //@ts-ignore
                                                                    if (e?.value >= 0) handleChildrenChange(e, index);
                                                                }}
                                                                showButtons
                                                                buttonLayout="horizontal"
                                                                decrementButtonClassName="p-button-secondary"
                                                                incrementButtonClassName="p-button-secondary"
                                                                incrementButtonIcon="pi pi-plus"
                                                                decrementButtonIcon="pi pi-minus"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {room.numOfChildren !== 0 && (
                                                    <>
                                                        {room.childAges.map((childAge, childIndex) => {
                                                            return (
                                                                <div className="col-12" key={"child-"+index+":"+childIndex}>
                                                                    <Dropdown optionLabel="name" optionValue="value" style={{width: "100%"}} value={childAge} options={allowedChildAges} onChange={(e)=>{handleChildAgeChange(e.value, index, childIndex)}}></Dropdown>
                                                                </div>
                                                            );
                                                        })}
                                                    </>
                                                )}
                                            </div>                        
                                        </div>
                                    </div>
                                    
                                );
                            })}
                            <div className="text-right">
                                <Button className="m-2" onClick={addRoom} label="Room" outlined icon="pi pi-plus"></Button>
                            </div>
                            <div className="m-3">
                                <Button style={{ width: "100%" }} onClick={toggleOverlay} label="Save"></Button>
                            </div>
                        </div>
                    </OverlayPanel>
                </div>
            </div>
        </>
    );
}

export default RoomPax;
